module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"brainDates":"{count} hjernedates","brainDatesCompletedOfTotal":"{completed} av {total} hjernedates"},"en":{"brainDates":"{count} brain dates","brainDatesCompletedOfTotal":"{completed} of {total} brain bates"}}')
  delete Component.options._Ctor
}
